module.exports = __webpack_public_path__ + "static/img/bg-10.ba68326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-10.png
// module id = MKXs
// module chunks = 0